import React, { useState } from "react";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import "../styles/NewPassword.css";
import config from "../services/config";
import { showAlert } from "../utilities/alertService";
import Loader from "../utilities/Loader";

export default function NewPassword({ onClose }) {
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [showNewPassword, setShowNewPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [loading, setLoading] = useState(false);


    const handleSubmit = async () => {
        if (!newPassword || !confirmPassword) {
            showAlert("warning", "Please fill out all fields.");
            return;
        }
        let errors = [];
        if (newPassword.length < 8) {
            errors.push("at least 8 characters");
        }
        if (!/[A-Z]/.test(newPassword)) {
            errors.push("one uppercase letter");
        }
        if (!/[a-z]/.test(newPassword)) {
            errors.push("one lowercase letter");
        }
        if (!/[0-9]/.test(newPassword)) {
            errors.push("one number");
        }
        if (!/[!@#$%^&*(),.?":{}|<>]/.test(newPassword)) {
            errors.push("one special character");
        }

        if (errors.length > 0) {
            showAlert("error", `Password must contain ${errors.join(", ")}.`);
            return;
        }
        if (newPassword !== confirmPassword) {
            showAlert("error", "Passwords do not match!");
            return;
        }

        try {
            setLoading(true);
            const resetToken = localStorage.getItem("reset_token");
            const email = localStorage.getItem("email");
            const payload = {
                email: email,
                new_password: newPassword,
                reset_token: resetToken,
            };
            const response = await config.customerResetPassword(payload);

            if (response.status === 200) {
                localStorage.removeItem("reset_token");
                localStorage.removeItem("email");
                showAlert("success", "Password has been reset successfully!", onClose);
            } else {
                showAlert("error", response.message || "Failed to reset password");
            }

        } catch (error) {
            console.error("Error resetting password:", error);
            showAlert("error", "Something went wrong while resetting your password. Please try again.");
        }
        finally {
            setLoading(false);
        }
    };

    return (
        <div className="password-overlay">
            <div className="password-box">
                <span className="close-btn" onClick={onClose}>✖</span>
                <h2>Set New Password</h2>
                {loading && <Loader />} 
                {/* New Password */}
                <div className="form-group password-field">
                    <div className="input-wrapper">
                        <input
                            type={showNewPassword ? "text" : "password"}
                            placeholder="Enter new password"
                            value={newPassword}
                            onChange={(e) => setNewPassword(e.target.value)}
                        />
                        <span
                            className="eye-icon"
                            onClick={() => setShowNewPassword(!showNewPassword)}
                        >
                            {showNewPassword ? <FaEyeSlash /> : <FaEye />}
                        </span>
                    </div>
                </div>

                {/* Confirm Password */}
                <div className="form-group password-field">
                    <div className="input-wrapper">
                        <input
                            type={showConfirmPassword ? "text" : "password"}
                            placeholder="Confirm new password"
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                        />
                        <span
                            className="eye-icon"
                            onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                        >
                            {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
                        </span>
                    </div>
                </div>

                <button onClick={handleSubmit}>Submit</button>
            </div>
        </div>
    );
}
